import { ArrowClockwiseIcon, WarningDiamondIcon } from '@phosphor-icons/react';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { ApiRequestError } from '@/lib/api-client';
import { EmptyState } from './empty-state';
import { Panel } from './panel';

/** Shown only when a route takes longer than `defaultPendingMs` to load. */
export function RoutePending() {
  return (
    <div
      className="flex min-h-[40vh] items-center justify-center text-muted-foreground"
      role="status"
      aria-live="polite"
    >
      <Spinner className="size-5" />
      <span className="sr-only">Loading</span>
    </div>
  );
}

/** Route-level failure: says what went wrong and offers the one useful action. */
export function RouteError({ error, reset }: ErrorComponentProps) {
  const message =
    error instanceof ApiRequestError
      ? error.message
      : 'This screen failed to load. Reload it, and if it keeps happening, check the system status.';
  return (
    <div className="flex min-h-[40vh] items-center justify-center px-4">
      <Panel className="w-full max-w-md">
        <EmptyState
          icon={WarningDiamondIcon}
          title="This screen didn't load"
          action={
            <Button variant="secondary" onClick={reset}>
              <ArrowClockwiseIcon />
              Reload screen
            </Button>
          }
        >
          {message}
        </EmptyState>
      </Panel>
    </div>
  );
}
